
import { Optional, utils } from 'apprise-core/utils'
import { useMultilang } from 'apprise-frontend-core/intl/multilang'

import { Tenant, TenantReference, unknownTenantId } from 'apprise-core/tenant'
import { useTenantExcludes } from 'apprise-frontend-iam/tenant/context'
import { useTenantStore } from './store'
import { useOracle } from 'apprise-frontend-iam/authz/oracle'



export type NextTenantDirectives = Partial<{

  model: Tenant
  onAdded: (added: Tenant) => any

}>

export const useNewTenant = () => {

  const { isExcluded } = useTenantExcludes()

  return (): Tenant => ({

    id: undefined!,
    name: {},
    guarded: false,
    description: {},
    tags: [],
    preferences: {},
    lifecycle: { state: isExcluded('active') ? 'active' : 'inactive' }
  })
}

export const useLoggedTenant = () => {
  
  const oracle = useOracle()
  const currentTenant = useTenantStore().lookup(oracle.tenant())

  return oracle.hasNoTenant() ? undefined : currentTenant

}


export const useTenantModel = () => {

  const newTenant = useNewTenant()

  const multilang = useMultilang()

  const self = {

    // tenants can always be searched by name and code, even if the code is not shown.
    // this witnesses to the familiarity of codes in the domain.
    textOf: (t: Optional<Tenant>) => multilang.join( t ? [t.name, t.code] : [])

    ,

    unknownTenant : (id?: Optional<TenantReference>): Tenant => ({

      ...newTenant(),
    
      name: { en: id || undefined! },
      id: unknownTenantId,
      preferences: {}
    
    })

    ,

    intern: (dto: Tenant) => dto

    ,

    extern: (t: Tenant) => t

    ,

    clone: (t: Tenant): Tenant => ({ ...utils().deepclone(t), id: undefined!, lifecycle: { state: 'inactive' } })


    ,

    comparator: (o1: Optional<Tenant>, o2:  Optional<Tenant>) => multilang.comparator(o1 ? o1.name : undefined, o2 ? o2.name : undefined )



  }

  return self

}


